const ADDRESS_BOOK_CATEGORY = 'address-book'

export const ADDRESS_BOOK_EVENTS = {
  EXPORT: {
    action: 'Export',
    category: ADDRESS_BOOK_CATEGORY,
  },
  DOWNLOAD_BUTTON: {
    action: 'Download address book',
    category: ADDRESS_BOOK_CATEGORY,
  },
  IMPORT: {
    action: 'Import',
    category: ADDRESS_BOOK_CATEGORY,
  },
  IMPORT_BUTTON: {
    action: 'Import address book',
    category: ADDRESS_BOOK_CATEGORY,
  },
  CREATE_ENTRY: {
    action: 'Create entry',
    category: ADDRESS_BOOK_CATEGORY,
  },
  EDIT_ENTRY: {
    action: 'Edit entry',
    category: ADDRESS_BOOK_CATEGORY,
  },
  DELETE_ENTRY: {
    action: 'Delete entry',
    category: ADDRESS_BOOK_CATEGORY,
  },
  SEND: {
    action: 'Send to contact',
    category: ADDRESS_BOOK_CATEGORY,
  },
}
